import React, { Component } from 'react' // MyCars
import ContenantClass from '../ContenantClass/ContenantClass'

class MyCars extends Component {

    noCopy = () => {
        alert('merci de ne pas copier le texte')
    }

    addStyle = (e) =>{
        
        e.target.classList.toggle("text-danger")
    }

    changeTittle = (e) =>{
        this.setState({
            titre : 'Mon nouveau Titre via setState'
        })
    }

    changeViaParam = (titre) => {
        this.setState({
            titre : titre
        })
    }

    changeViaBind = (param) => {
        this.setState({
            titre : param
        })
    }

    state = {
         titre : 'en dur via state'
    }

    render(){
        return(

            <div>
                <h1 onMouseOver={this.addStyle}>Catalogue voiture</h1>
                <p onCopy={this.noCopy}>Lorem absout qsdf qsdf qsdf qsdfqsdf qsdf qsdf qsdf qsdf qsf</p>
                <ContenantClass color="red">  {this.state.titre}</ContenantClass>

                <ContenantClass >  </ContenantClass>
                <ContenantClass color="grey"> </ContenantClass>
                <button onClick={this.changeTittle} >Changer le nom en dur</button>
                <button onClick={() => this.changeViaParam('titre via param')} >titre via param</button>
                <button onClick={this.changeViaBind.bind(this, 'titre via bind')} >titre via bind</button>
            </div>
            
        )
    }
}

export default MyCars;